<template>
  <div class="p-header">
    <div class="logo-box box-flex">
      <div
        class="menu-icon left"
        v-if="topNavigationLeft"
        :class="menuIsShow ? 'show-menu' : ''"
        @click="menuClick"
        v-exposure="{ eid: `101_0_0_127` }"
        :data-id="`101_0_0_127`"
      >
        <img :src="celanbtn" fit="contain" alt />
      </div>
      <div class="logo" @click="toLink('/home')">
        <img v-if="logo" style="height: 100%; pointer-events: none" :src="logo" fit="contain" alt />
      </div>
    </div>
    <span class="slogan" v-if="slogan">{{ slogan }}</span>
    <div class="topnav" v-if="topNavs">
      <div
        class="topnav-item"
        v-for="(item, index) in topNavs"
        :key="item.name"
        @click="handleTopNav(item, `101_30_0_${index}`)"
      >
        <img
          class="topnav-item-icon"
          v-if="item.Languages.icon"
          :src="$utils.returnImgUrl(item.Languages.icon)"
          alt=""
        />
        <div
          class="topnav-item-name"
          v-exposure="{ eid: `101_30_0_${index}`, jump_vlaue: item.jump }"
          :data-id="`101_30_0_${index}`"
        >
          {{ item.Languages.name }}
        </div>
      </div>
    </div>
    <div class="right-wrap" :style="{ paddingRight: $px2rem(newPaddingRight) }">
      <div class="action-wrap">
        <emailIcon />
        <div @click="clickSearch" class="search-icon" v-exposure="{ eid: `101_0_0_128` }" :data-id="`101_0_0_128`">
          <img class="icon" src="@/assets/user/search.png" alt="" />
        </div>
        <div class="login-btn" v-if="!isLogin">
          <el-button
            class="lgoin-button"
            v-for="(item, i) in menuItems"
            :key="i"
            @click="clickFun(item.value, item.eid)"
            size="small"
            v-exposure="{ eid: item.eid }"
            :data-id="item.eid"
            >{{ item.title }}</el-button
          >
        </div>
        <div class="head-user-info box-flex" v-else>
          <div id="vStep" class="godVip-box" v-exposure="{ eid: `101_0_0_129` }" :data-id="`101_0_0_129`">
            <!-- <label
              v-if="UserCoins.length === 1"
              class="el-dropdown-link"
              style="position: relative"
              @click="goWalletDetail"
            >
              <img :src="$utils.returnImgUrl(curCoin.coinIcon)" alt />
              <span style="margin-right: 2px">{{ curCoin.symbol }}</span>
              <span v-if="inGame">{{ $t("Datalang.HomePage_TITLE_ingaming") }}</span>
              <span v-else>{{ divideSymbol(curCoin.allChips, curCoin.accuracy) }}</span>
            </label> -->
            <el-dropdown
              @command="handleCheck"
              ref="messageDrop"
              @visible-change="visibleChange"
              :hide-on-click="true"
              @click.native="dropdown"
              trigger="click"
              :disabled="
                inGame ||
                getPacketConfig.withdrawMode === 'WITHDRAW_MODE_LIMIT' ||
                getPacketConfig.withdrawMode === 'WITHDRAW_MODE_CLOSE'
              "
            >
              <!-- 单一货币展示 -->
              <div v-if="coinStyle === 2" class="el-dropdown-link el-dropdown-link1" style="position: relative">
                <div>
                  <div class="flex">
                    <img :src="$utils.returnImgUrl(curCoin.coinIcon)" alt />
                    <span style="margin-right: 2px">{{ curCoin.symbol }}</span>
                    <span v-if="inGame">（{{ $t("Datalang.HomePage_TITLE_ingaming") }}）</span>
                    <span v-else>{{ divideSymbol(curCoin.chips, curCoin.accuracy) }}</span>
                  </div>
                  <div v-if="Number(curCoin.experience) > 0" class="flex">
                    <img :src="$utils.returnImgUrl(curCoin.freeIcon || curCoin.coinIcon)" alt />
                    <span style="margin-right: 2px">{{ curCoin.freeSymbol || curCoin.symbol }}</span>
                    <span v-if="inGame">（{{ $t("Datalang.HomePage_TITLE_ingaming") }}）</span>
                    <span v-else>{{ divideSymbol(curCoin.experience, curCoin.accuracy) }}</span>
                  </div>
                </div>
                <i
                  v-if="
                    getPacketConfig.withdrawMode !== 'WITHDRAW_MODE_LIMIT' &&
                    getPacketConfig.withdrawMode !== 'WITHDRAW_MODE_CLOSE'
                  "
                  class="el-icon-arrow-down"
                  :class="{
                    'is-reverse': boxVisible,
                  }"
                  style="margin-left: 5px; font-weight: bold"
                ></i>
              </div>
              <!-- 多货币 -->
              <label v-else class="el-dropdown-link" style="position: relative">
                <img :src="$utils.returnImgUrl(curCoin.coinIcon)" alt />
                <span style="margin-right: 2px">{{ curCoin.symbol }}</span>
                <span v-if="inGame">（{{ $t("Datalang.HomePage_TITLE_ingaming") }}）</span>
                <span v-else>{{ divideSymbol(curCoin.allChips, curCoin.accuracy) }}</span>
                <i
                  v-if="
                    getPacketConfig.withdrawMode !== 'WITHDRAW_MODE_LIMIT' &&
                    getPacketConfig.withdrawMode !== 'WITHDRAW_MODE_CLOSE'
                  "
                  class="el-icon-arrow-down"
                  :class="{
                    'is-reverse': boxVisible,
                  }"
                  style="margin-left: 5px; font-weight: bold"
                ></i>
              </label>
              <el-dropdown-menu slot="dropdown" :style="computeStyle2" class="wallet_list_header">
                <template v-if="coinStyle === 2">
                  <el-dropdown-item class="qbMode">
                    <div class="qbModeMain">
                      <div class="qbModeMainTop">
                        <div>{{ $t("Datalang.home_deposit_balance") }}</div>
                        <span class="el-icon-question" @click.stop="onShowInfoModal(3, 1)"></span>
                      </div>
                      <div class="qbModeMainCon">
                        <div class="amount">{{ UserCoins[0]?.symbol + ' ' + divideSymbol(UserCoins[0]?.chips) }}</div>
                        <div class="qbModeMainConRight">
                          <div></div>
                          <div class="btn" @click.stop="goWithdraw(1)" align="center">{{ $t("Datalang.Menu_BTM_withdraw") }}</div>
                        </div>
                      </div>
                    </div>
                    <div class="qbModeMain mt10" v-if="UserCoins[0]?.experience > 0">
                      <div class="qbModeMainTop">
                        <div>{{ $t("Datalang.home_exprience") }}</div>
                        <span class="el-icon-question" @click.stop="onShowInfoModal(3, 2)"></span>
                      </div>
                      <div class="qbModeMainCon">
                        <div class="amount">{{ (UserCoins[0]?.freeSymbol || UserCoins[0]?.symbol) + ' ' + divideSymbol(UserCoins[0]?.experience) }}</div>
                        <div class="qbModeMainConRight">
                          <div></div>
                          <div class="btn" @click.stop="goWithdraw(2)" align="center">{{ getBtnTxt() }}</div>
                        </div>
                      </div>
                    </div>
                    <div class="qbModeMain mt10" v-if="hasCommissionWallet">
                      <div class="qbModeMainTop">
                        <div>{{ $t("Datalang.Home_Commission_Balance5") }}</div>
                        <span class="el-icon-question" @click.stop="onShowInfoModal(3, 3)"></span>
                      </div>
                      <div class="qbModeMainCon">
                        <div class="amount">{{ UserCoins[0]?.symbol + ' ' + divideSymbol(UserCoins[0]?.commission) }}</div>
                        <div class="qbModeMainConRight">
                          <div class="btn mr10" @click.stop="goHandleChange(UserCoins[0]?.coinCode)" align="center">{{ $t("Datalang.Transfer_to_ACCOUNT") }}</div>
                          <div class="btn" @click.stop="goWithdraw(3)" align="center">{{ $t("Datalang.Menu_BTM_withdraw") }}</div>
                        </div>
                      </div>
                    </div>
                  </el-dropdown-item>
                </template>
                <template v-else>
                  <el-dropdown-item class="qbHeaer">
                    <div align="left">
                      {{ $t("Datalang.Menu_BTM_mywallet") }}
                      <span v-if="rateList.length > 0" class="el-icon-question" @click="onShowInfoModal(1)"></span>
                    </div>
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-for="(item, i) in UserCoins"
                    :command="item.coinCode"
                    :key="i"
                    class="qbItem"
                    :disabled="curCoin.coinCode === item.coinCode" 
                  >
                    <div
                      class="qbDiv"
                      v-if="isTgAppCoinCode(item)"
                    >
                      <img :src="$utils.returnImgUrl(item.coinIcon)" alt />
                      <span v-if="item.isExperienceCoinCode">{{ $t('Datalang.home_exprience') }}&nbsp;&nbsp;</span>
                      <span v-else>{{ item.coinCode }}&nbsp;&nbsp;</span>
                      <div class="chips">
                        <div class="symbol_coin">{{ divideSymbol(item.isExperienceCoinCode ? item.experience : item.chips) }}</div>
                      </div>
                    </div>
                    <div class="experienceDiv" v-if="item.isExperienceCoinCode">
                      <ExperienceWallet :experienceObj="item"/>
                    </div>
                  </el-dropdown-item>
                  <el-dropdown-item class="qbFooter" :disabled="inGame">
                    <span
                      :class="`walletBtn ${inGame ? 'disable_btn' : ''} ${isFirst ? 'first' : ''}`"
                      @click="toWallet"
                      align="center"
                      >{{ $t("Datalang.Menu_BTM_mywallet") }}</span
                    >
                  </el-dropdown-item>
                </template>
              </el-dropdown-menu>
            </el-dropdown>
            <!-- 自定义提示 -->
            <!-- <div v-if="isShowTip" class="dropdown-tip">{{ `${curCoin.freeSymbol || curCoin.symbol} ${$t("Datalang.home_withdraw_now")}` }}<span class="dropdown-tip-arrow"></span></div> -->
          </div>
          <div
            class="recharge"
            :style="`margin-left: ${$px2rem(16)}`"
            @click="showCharge"
            v-exposure="{ eid: `101_0_0_130` }"
            :data-id="`101_0_0_130`"
          >
            {{ $t("Datalang.newly_deposit9") }}
          </div>
          <el-button
            v-if="getPacketConfig.withdrawMode !== 'WITHDRAW_MODE_CLOSE'"
            slot="reference"
            type="primy"
            class="withdraw"
            :style="`margin-left: ${$px2rem(16)}`"
            @click="showExchange"
            size="small"
            v-exposure="{ eid: `101_0_0_131` }"
            :data-id="`101_0_0_131`"
          >
            {{ $t("Datalang.newly_withdraw5") }}
            <div class="firstWithdrawTis-wrap" @click="clickBubble" v-if="showFirstWithdrawTis">
              <div class="text1">{{ firstWithdrawText1 }}</div>
              <div class="bg"></div>
              <div class="triangle"></div>
            </div>
          </el-button>
        </div>

        <template v-if="isLogin">
          <div class="user-wrap">
            <el-dropdown
              trigger="click"
              placement="bottom-start"
              :style="`height: ${$px2rem(46)}; line-height: ${$px2rem(46)}; margin-left: ${$px2rem(10)}`"
              @command="handleCommand"
            >
              <span class="avatarimg">
                <el-avatar
                  :size="38"
                  style="margin-top: 3px"
                  :src="$utils.avatarUrl()"
                  fit="cover"
                  v-exposure="{ eid: `101_0_0_133` }"
                  :data-id="`101_0_0_133`"
                ></el-avatar>
              </span>
              <el-dropdown-menu slot="dropdown" class="dropdown-box">
                <el-dropdown-item v-for="(item, i) in dropdownMenu" :key="i" :command="item">
                  <img class="icon" :src="item.icon" alt />
                  <span class="title">{{ item.title }}</span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <div class="account_info">
              <div>{{ userData.nickname }}</div>
              <div class="account_vip">
                <img class="p_vip" :src="p_vip" alt />
                <span>VIP{{ userData.level }}</span>
              </div>
            </div>
          </div>
        </template>
        <!-- v-if="!isTgApp" -->
        <el-dropdown
          trigger="click"
          placement="bottom-start"
          style="margin-left: 12px; display: flex; align-items: center"
          @command="changeFun"
        >
          <div class="cur-lang-wrap"><img class="cur-lang-icon-new" :src="getlangIcon" alt /></div>
          <el-dropdown-menu slot="dropdown" :style="computeStyle">
            <el-dropdown-item v-for="item in locales" :key="item.locale" :command="item.locale">
              <div class="lang-row-wrap">
                <img :src="item.icon" class="language-icon" alt />
                <!-- :src="require(`@/assets/login/login_warning.png`)" -->
                <!-- <img :src="require(`@/lobby_common/assets/country/${item.locale}}.png`)" class="language-icon" alt /> -->
                <span class="language-title">{{ item.title }}</span>
              </div>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <PopupDialog
        ref="PopupDialog"
        width="500px"
        :dataOpt="{
          title: getTitle(),
        }"
        :show.sync="PopupWindowShow"
        @close="closeFun"
      >
        <template #center>
          <div class="modal-info">
            <div v-if="infoType === 1">
              <p>1. {{ $t("Datalang.Wallet_TEXT_circulationcurrenc") }}</p>
              <template v-if="rateList.length">
                <div v-for="item in rateList" :key="item.id">
                  1{{ item.fromCoin }} ≈ {{ item.rate }} {{ item.toCoin }}
                </div>
              </template>
              <p>2. {{ $t("Datalang.Wallet_TEXT_defaultwallet") }}</p>
            </div>
            <div v-if="infoType === 2">
              <p>{{ $t("Datalang.home_withdrawable") }}</p>
            </div>
            <div v-if="infoType === 3">
              <p>{{ getTxt() }}</p>
            </div>
            <div class="btn-content">
              <el-button round type="primary" @click="closeFun">{{ $t("Datalang.Withdrawl_TIP_getit") }}</el-button>
            </div>
          </div>
        </template>
      </PopupDialog>
    </div>
    <div
      class="menu-icon right"
      v-if="topNavigationRight"
      :class="menuIsShow ? '' : 'show-menu'"
      @click="menuClick"
      v-exposure="{ eid: `101_0_0_127` }"
      :data-id="`101_0_0_127`"
    >
      <img :src="celanbtn" fit="contain" alt />
    </div>
  </div>
</template>

<script>
import p_vip from "@/assets/user/p_vip.png";

import dimg4 from "@/assets/user/shezhi_caijin.png";
import dimg14 from "@/assets/user/shezhi_yongjin.png";
import dimg1 from "@/assets/user/shezhi_chongzhi.png";
import dimg6 from "@/assets/user/shezhi_gerenziliao.png";
import dimg9 from "@/assets/user/shezhi_huodong.png";
import dimg7 from "@/assets/user/shezhi_jiaoyijilu.png";
import dimg3 from "@/assets/user/shezhi_qianbao.png";
import dimg2 from "@/assets/user/shezhi_tixian.png";
import dimg10 from "@/assets/user/shezhi_touzhu.png";
import dimg12 from "@/assets/user/shezhi_tuichu.png";
import dimg5 from "@/assets/user/shezhi_vip.png";
import dimg11 from "@/assets/user/shezhi_xiaoxi.png";
import dimg8 from "@/assets/user/shezhi_yaoqing.png";
import celanbtn from "@/assets/home/celan_btn.png";
import zengli from "@/assets/user/shezhi_zengli.png";
import { selectWallet } from "@/lobby_common/api/user_gen";
import { killPlayerUser } from "@/lobby_common/api/game_gen";
import { getCoinExchangeRateData } from "@/lobby_common/utils/utils.js";
// import Jb from "@/assets/img/jb.png";
// import UserIcon from "@/assets/img/txk.png";
import PopupDialog from "@/components/PopupDialog";
import hideGmae from "@/lobby_common/mixins/hideGmae.js";
import { divideAccuracy, divideSymbol, isGame, formatLang } from "@/lobby_common/utils/utils.js";
import { debounce } from "@/lobby_common/utils/index.js";
import { mapActions, mapGetters } from "vuex";
import { setLocale } from "@/lobby_common/locale";
import { getAnyZoneTime } from "@/lobby_common/utils/date";
import { goJoinEvent, getTxtFun, goWithdrawFun, getBtnTxtFun, goHandleChangeFun } from "@/lobby_common/utils/utils.js";
import { updateUserLanguage } from "@/lobby_common/api/user_gen.js";
import { bigAdd } from "@/lobby_common/utils/big.js";
import ExperienceWallet from "@/components/experienceWallet/index.vue";
import emailIcon from "@/lobby_common/mixins_components/emailIcon/index.vue";
import { clearAllDB } from '@/lobby_common/utils/jsonCache.js'
export default {
  name: "p-header3",
  mixins: [hideGmae],
  components: { PopupDialog, ExperienceWallet, emailIcon },
  data() {
    return {
      bigAdd,
      boxVisible: false,
      formatLang,
      dimg1,
      dimg2,
      dimg3,
      dimg4,
      dimg14,
      dimg5,
      dimg6,
      dimg7,
      dimg8,
      dimg9,
      dimg10,
      dimg11,
      dimg12,
      zengli,
      celanbtn,
      killPlayerUser,
      sportsBrand: {
        brand_id: 14,
      },
      // Jb,
      // UserIcon,
      divideAccuracy,
      divideSymbol,
      listData: [],
      // curCoin: {},
      obj: {},
      UserCoins: [],
      isGame: isGame,
      PopupWindowShow: false,
      // rateList: [],
      isFirst: false,
      timer: null,
      bTime: [],
      curNum: undefined,
      p_vip,
      setLocale,
      inGame: false,
      isApi: false,
      paddingRight: 0,
      infoType: 1,
      walletTypeTxt: 1,
      // rateLoading: false,
      // coinExchangeRate: [],
    };
  },
  watch: {
    "$route.path": {
      handler: function () {
        this.inGame = !!this.isGame();
      },
      deep: true,
      immediate: true,
    },
    getUserCoins: {
      handler: function () {
        this.handeleUserCoins();
      },
      deep: true,
      immediate: true,
    },
    isLogin: {
      handler: function () {
        this.getUserFirstWithdrawHintFun(this.getPacketConfig.coinCode);
      },
      immediate: true,
    },
    menuIsShow: {
      handler: function () {
        this.commonSySize();
      },
      deep: true,
      immediate: true,
    },
  },
  async created() {
    // that.getGamelistFun();
    // that.getTime();
    window.addEventListener("resize", this.commonSySize);
    this.$nextTick(() => {
      this.commonSySize();
    });
  },
  computed: {
    hasCommissionWallet() {
      const obj = this.$store.getters.getPacketConfig?.appConfig || {};
      const walletType = obj.wallets || [];
      return walletType.includes("COMMISSION_WALLET");
    },
    getAppConfig() {
      return this.$store.getters.getPacketConfig?.appConfig || {};
    },
    isNewWithdrawMode() {
      let withdrawMode = this.getAppConfig.withdrawMode
      return withdrawMode === 'WITHDRAW_MODE_FREE_GOLD'
    },
    isShowTip() {
      let promptFreeGoldWithdraw = this.getAppConfig.promptFreeGoldWithdraw ? Number(this.getAppConfig.promptFreeGoldWithdraw) : 0
      return this.isNewWithdrawMode && promptFreeGoldWithdraw !== 0 && Number(this.curCoin.experience) > promptFreeGoldWithdraw
    },
    // 是否有体验彩金钱包
    hasExperienceWallet() {
      return this.getAppConfig?.wallets?.includes("EXPERIENCE_WALLET") || false;
    },
    computeStyle() {
      return `max-height: 500px; padding-bottom: ${this.isMobile ? "8px" : "22px"};overflow: auto`;
    },
    computeStyle2() {
      if (this.hasExperienceWallet) {
        return `max-height: 500px; padding-bottom:9px;overflow: auto`;
      }
      return `max-height: 500px; padding-bottom:22px;overflow: auto`;
    },
    newPaddingRight() {
      if (this.topNavigationRight) {
        return this.paddingRight - 40;
      }
      return this.paddingRight;
    },
    hidGift() {
      const userInfo = this.$store.getters.user || {};
      const giftInfo = this.$store.getters.getPacketConfig?.appConfig?.gift || {};
      let flag = true;
      if (giftInfo.status !== "ROW_STATUS_ENABLE") {
        flag = true;
      } else {
        flag = false;
      }
      return flag;
    },
    topNavigationTemplate() {
      return this.$store.getters.getPacketConfig?.topNavigationTemplate || {};
    },
    coinStyle() {
      return Number(this.topNavigationTemplate.coinStyle)
    },
    topNavigation() {
      return this.$store.getters.getPacketConfig?.topNavigationTemplate?.pc || null;
    },
    topNavigationLeft() {
      return this.topNavigation && this.topNavigation.style === 3 && this.topNavigation.menuPosition === 1;
    },
    topNavigationRight() {
      return this.topNavigation && this.topNavigation.style === 3 && this.topNavigation.menuPosition === 2;
    },
    slogan() {
      return (
        (this.topNavigation &&
          this.topNavigation.style === 3 &&
          this.topNavigation.center === 1 &&
          this.topNavigation.promotionLanguages?.promotion) ||
        ""
      );
    },
    topNavs() {
      if (
        this.topNavigation &&
        this.topNavigation.style === 3 &&
        this.topNavigation.center === 2 &&
        this.topNavigation.functions
      ) {
        return this.topNavigation.functions || [];
      }
      return null;
    },
    firstWithdrawHint() {
      return this.$store.getters.getFirstWithdrawHint || {};
    },
    firstWithdrawText1() {
      // vip激活 首提text
      const str =
        this.getPacketConfig.symbol +
        divideAccuracy(this.firstWithdrawHint.firstWithdrawAmount, this.getPacketConfig.accuracy);
      return this.formatLang(this.$t("Datalang.newly_ten_withdraw"), [str]);
    },
    // 开启首提并满足条件
    showFirstWithdrawTis() {
      const data = this.firstWithdrawHint;
      return (
        data.isFirstWithdraw === "STATUS_BOOL_TRUE" &&
        data.isSatisfy === "STATUS_BOOL_TRUE" &&
        Number(data.firstWithdrawAmount) &&
        !this.userData.isWithdraw &&
        !data.bubble
      );
    },
    userInfo() {
      return JSON.parse(JSON.stringify(this.$store.getters.user));
    },
    defaultCoinCode() {
      return this.userInfo.coinCode;
    },
    locales() {
      return this.$store.getters.getLocalesList;
    },
    getUserCoins() {
      return this.$store.getters.getUserCoins;
    },
    curCoin() {
      return this.$store.getters.getCurCoin;
    },
    rateList() {
      return this.$store.getters.getRateList || [];
    },
    coinExchangeRate() {
      return this.$store.getters.getCoinExchangeRate || [];
    },
    rateLoading() {
      return this.$store.getters.getRateLoading;
    },
    getlangIcon() {
      const arr =
        this.locales.filter((v) => {
          return v.locale === this.$store.getters.getLang;
        }) || [];
      // console.log(arr);
      return arr[0] ? arr[0].icon : "";
    },
    getData() {
      return this.$store.getters.getData;
    },
    inCasino() {
      const route = this.$route;
      const ret = ["/other/"].some((f) => route.path.includes(f));
      return !ret;
    },
    isPayNum() {
      const route = this.$route;
      const ret = ["/other/", "/games/", "/payGame/"].some((f) => route.path.includes(f));
      // const text = ret && Number(this.userData?.chips) <= 0;
      return ret ? `(${this.$t("Datalang.HomePage_TITLE_ingaming")})` : divideAccuracy(this.userData?.chips);
    },
    isTy() {
      return this.listData.find((e) => e.gameGroupSid === 115000101);
    },
    coinSymbol() {
      return this.$store.getters.user?.coin_symbol;
    },
    logo() {
      return this.$utils.returnImgUrl(this.$store.getters.getPacketConfig?.site?.indexLogo);
    },
    getPacketConfig() {
      return this.$store.getters.getPacketConfig?.appConfig || {};
    },
    popFullscreen() {
      return this.$store.getters.getFullscreen;
    },
    isLogin() {
      return this.$store.getters.login;
    },
    userData() {
      return this.$store.getters.user;
    },
    activityshowdata() {
      return this.$store.getters.activityshow;
    },
    menuItems() {
      const items = [
        {
          title: this.$t("Datalang.promotion_TITLE_Login"),
          type: "text",
          value: 0,
          eid: `101_0_0_142`,
        },
        {
          title: this.$t("Datalang.promotion_TITLE_Register"),
          type: "primary",
          value: 1,
          eid: `101_0_0_143`,
        },
      ];
      return items;
    },
    dropdownMenu() {
      let items = [
        {
          title: this.$t("Datalang.Menu_BTM_recharge"),
          route: "Charge",
          type: "chargeExchange",
          icon: this.dimg1,
          id: 10020017,
        },
        {
          title: this.$t("Datalang.Menu_BTM_withdraw"),
          hide: this.getPacketConfig.withdrawMode === "WITHDRAW_MODE_CLOSE",
          route: "Exchange",
          type: "Exchange",
          icon: this.dimg2,
          id: 10020015,
        },
        {
          title: this.$t("Datalang.Menu_BTM_mywallet"),
          hide:
            this.getPacketConfig.withdrawMode === "WITHDRAW_MODE_LIMIT" ||
            this.getPacketConfig.withdrawMode === "WITHDRAW_MODE_CLOSE",
          route: "/user/wallet",
          type: "router",
          icon: this.dimg3,
        },
        {
          title: this.$t("Datalang.Menu_BTM_VIPcenter"),
          route: "/user/vip",
          type: "router",
          icon: this.dimg5,
          id: 10020005,
        },
        {
          title: this.$t("Datalang.Menu_BTM_playerinfo"),
          route: "/user",
          type: "router",
          icon: this.dimg6,
          id: 11060001,
        },
        {
          title: this.$t("Datalang.Menu_BTM_tranctionrecord"),
          route: "/user/walletRecord",
          type: "router",
          icon: this.dimg7,
        }, // 新  交易记录
        {
          title: this.$t("Datalang.Menu_BTM_intivefirend"),
          // hide: this.$store.getters.getPacketConfig?.packet_config?.promote_method === 2,
          route: "/user/distribution",
          type: "router",
          icon: this.dimg8,
        },
        {
          title: this.$t("Datalang.newly_bonus"),
          route: "/events?tab=1",
          type: "router",
          icon: this.dimg9,
          id: 10020009,
        },
        // {
        //   title: this.$t("Datalang.Menu_BTM_bettingrecord"),
        //   route: "/user/gameRecord",
        //   icon: this.dimg10,
        //   type: "router",
        // }, // 新  投注记录
        {
          title: this.$t("Datalang.Menu_BTM_messagecenter"),
          route: "/user/notice",
          type: "router",
          icon: this.dimg11,
        }, // 新  消息中心
        {
          icon: this.zengli,
          title: this.$t("Datalang.home_Gift"),
          route: "/user/givingGift",
          type: "router",
          hide: this.hidGift,
        },
        {
          title: this.$t("Datalang.Menu_BTM_logout"),
          route: "signOut",
          type: "signOut",
          icon: this.dimg12,
          id: 11060011,
          hide: this.isTgApp,
        },
      ];

      items = items.filter((item) => item.hide !== true);

      return items;
    },
    isMobile() {
      return this.$store.getters.getIsMobile;
    },
    ...mapGetters(["menuIsShow"]),
  },
  mounted() {},
  methods: {
    commonSySize() {
      const ele = document.getElementById("main-content");
      const right = this.getDistanceFromRight(ele);
      this.paddingRight = right;
    },
    getDistanceFromRight(element) {
      if (!element) return 0;
      const rect = element?.getBoundingClientRect();
      const windowWidth = window.innerWidth || document.documentElement.clientWidth;
      return windowWidth - rect.right;
    },
    handleTopNav(item, eid) {
      this.$eventPost("click", {
        eid,
        time: Date.now(),
        jump_vlaue: item.jump,
      });
      goJoinEvent(item.jump);
    },
    // 点击气泡后不展示
    clickBubble() {
      this.$store.commit("setFirstWithdrawHint", { bubble: true });
    },
    // 首提
    getUserFirstWithdrawHintFun: debounce(async function (coinCode) {
      this.$store.dispatch("getUserFirstWithdrawHintAction", { coinCode });
    }, 100),
    clickSearch() {
      this.$eventPost("click", {
        eid: `101_0_0_128`,
        time: Date.now(),
      });
      this.$Bus.$emit("changeSearchDrawer");
    },
    handeleUserCoins() {
      const obj = this.getUserCoins;
      const data = { ...obj };
      const wallets = data.wallets || [];
      if (wallets.length === 0) {
        return false;
      }
      let UserCoins = [...wallets];
      UserCoins = UserCoins.map((v) => {
        // 充值 可提 彩金
        v.chips = this.divideAccuracy(
          Number(v.rechargeWallet) + Number(v.withdrawWallet) + Number(v.bonusWallet),
          v.accuracy
        );
        // 充值 可提 彩金 免费彩金
        v.allChips = this.divideAccuracy(
          Number(v.rechargeWallet) + Number(v.withdrawWallet) + Number(v.bonusWallet) + Number(v.experienceWallet),
          v.accuracy
        );
        v.isDefaultCoin = v.coinCode === this.defaultCoinCode; // 当前货币是否为会员货币
        // 体验彩金
        v.experience =
          this.hasExperienceWallet ? this.divideAccuracy(Number(v.experienceWallet), v.accuracy) : 0;
        // 佣金余额
        v.commission = Number(v.commissionWallet) ? this.divideAccuracy(Number(v.commissionWallet), v.accuracy) : 0;
        return { ...v };
      });
      const selectedCoinCode = data.selectedCoinCode || UserCoins[0]?.coinCode;

      this.$set(this, "UserCoins", UserCoins);
      if (!this.rateList.length) {
        this.getRateList(data);
      }
      this.afterGetCoincode(selectedCoinCode);
    },
    menuClick() {
      this.$eventPost("click", {
        eid: `101_0_0_127`,
        time: Date.now(),
      });
      this.setMenuBar(!this.menuIsShow);
    },
    toLink(path) {
      // localStorage.setItem("after_quick", true);
      this.$router.push(path || "/");
    },
    // getTime() {
    //   // 美东 -4时间
    //   // const _this = this
    //   if (this.timer === null) {
    //     this.timer = setInterval(() => {
    //       this.bTime = [];
    //       this.curNum = this.curNum || 0;
    //       this.bTime.push({
    //         label: getAnyZoneTime(new Date().getTime(), -4).substring(11) + " (GMT-4:00)",
    //         value: 0,
    //       });
    //       this.bTime.push({
    //         label: getAnyZoneTime(new Date().getTime(), +8).substring(11) + " (GMT+8:00)",
    //         value: 1,
    //       });
    //     }, 1000);
    //   }
    // },
    triggerXiala() {
      this.$refs.timeSelect.focus();
    },

    async changeFun(val) {
      await clearAllDB();
      let code = 0;
      if (this.$store.getters.taken) {
        const res = (await updateUserLanguage({ language: val })) || {};
        code = res.code;
      }
      if (code === 0) {
        this.setLocale(val);
        this.$router.push("/home");
        // this.$Bus.$emit("reload")
        setTimeout(() => {
          window.location.reload();
        }, 100);
      }
    },

    visibleChange(val) {
      if (val) {
        // console.log(val);
        const flag = localStorage.getItem("firstVisit");
        // console.log(flag, "flag");
        this.isFirst = !flag;
      }
      this.boxVisible = val;
    },
    async onShowInfoModal(type, walletTypeTxt) {
      this.infoType = type;
      this.walletTypeTxt = walletTypeTxt || 1
      this.PopupWindowShow = true;
    },
    getTitle() {
      if(this.infoType === 1) {
        return this.$t('Datalang.Wallet_BTM_switchwalletdescription')
      }
      if(this.infoType === 2) {
        return this.$t('Datalang.home_exprience')
      }
      if(this.infoType === 3) {
        return this.$t('Datalang.Recharge_TIP_tip')
      }
    },
    getTxt() {
      let walletTypeTxt = this.walletTypeTxt // 1真实钱包  2免费金币钱包  3佣金钱包
      return getTxtFun(walletTypeTxt)
    },
    goWithdraw(type){
      const msg = ['', 'currency_display_cash_withdraw', 'currency_display_free_coin_withdraw', 'currency_commission_withdraw']
      this.$eventPost(msg[type]);
      goWithdrawFun(type)
    },
    getBtnTxt() {
      return getBtnTxtFun()
    },
    goHandleChange(coinCode) {
      goHandleChangeFun(coinCode)
    },
    closeFun() {
      this.PopupWindowShow = false;
    },
    async getRateList(coinList = {}) {
      // 共用汇率loading，只请求一次汇率接口
      if (this.rateLoading) return;
      this.$store.commit("setRateLoading", true);
      const arr = coinList.wallets || [];
      const checkedCoin = arr.find((item) => item.coinCode === coinList.selectedCoinCode) || {};
      let dataList = [];
      if (this.coinExchangeRate.length) {
        dataList = this.coinExchangeRate;
      } else {
        const { code, data } = await getCoinExchangeRateData();
        if (code === 0) {
          dataList = data.list || [];
          // 存汇率表
          this.$store.commit("setCoinExchangeRate", dataList);
        }
      }
      const walletCoin = arr.map((item) => item.coinCode) || [];
      const brr = dataList.filter((item) => item.toCoin === checkedCoin.coinCode) || [];
      const _arr = brr.filter((item) => walletCoin.includes(item.fromCoin)) || [];
      // 存当前货币汇率数据
      this.$store.commit("setRateList", _arr);
      this.$store.commit("setRateLoading", false);
    },

    // 前往钱包
    toWallet() {
      this.$router.push("/user/wallet");
    },
    goWalletDetail() {
      if (this.UserCoins?.length === 1) {
        this.$router.push("/user/wallet");
      }
    },
    afterGetCoincode(command) {
      // console.log("0803-afterGetCoincode", this.UserCoins, command);
      if (!command) return false;
      // const { code } = await this.killPlayerUser({});
      // if (code !== 0) {
      //   return;
      // }
      const arr = this.UserCoins.filter((v) => {
        return v.coinCode === command;
      });
      if (arr && arr.length) {
        this.$store.commit("setCurCoin", arr[0]);
      }
      localStorage.setItem("coinCode", command);
      localStorage.setItem("Cur_Chips", this.curCoin.isExperienceCoinCode ? this.curCoin.experience : this.curCoin.chips)
      this.$store.commit("setSelectCoin", command);
    },
    handleHashChange({ tag }) {
      const path = `/search/all/all`;
      localStorage.setItem("curTag", JSON.stringify([tag]));
      const query = { flag: new Date().getTime() };
      this.$router.push({ path: path, query: query });
    },
    dropdown() {
      if (this.$refs.messageDrop.visible === true) {
        this.$refs.messageDrop.visible = false;
      } else {
        this.$eventPost("currency_display_click");
        this.$refs.messageDrop.visible = true;
      }
    },
    async handleCheck(val) {
      // this.handleCheckCoinCode(val);
      if (!val) return false;
      if(val.includes('experience')) return false
      const { code } = await this.killPlayerUser({});
      if (code !== 0) {
        return;
      }
      const arr = this.UserCoins.filter((v) => {
        return v.coinCode === val;
      });
      if (arr && arr.length) {
        this.$store.commit("setCurCoin", arr[0]);
      }
      localStorage.setItem("coinCode", val);
      localStorage.setItem("Cur_Chips", this.curCoin.isExperienceCoinCode ? this.curCoin.experience : this.curCoin.chips)
      this.$eventPost("click", {
        eid: `101_0_0_129`,
        coinCode: val,
        time: Date.now(),
      });
      selectWallet({ coinCode: val }).then((res) => {
        this.$store.commit("setSelectCoin", val);
        this.$store.dispatch("getUserInfo");
        if (isGame()) {
          // 在游戏中就刷新页面
          window.location.reload();
        }
        this.$Bus.$emit("reload");
      });
    },
    async handleCheckCoinCode(command, once = false) {
      if (!command) return false;
      // const { code } = await this.killPlayerUser({});
      // if (code !== 0) {
      //   return;
      // }
      const arr = this.UserCoins.filter((v) => {
        return v.coinCode === command;
      });
      if (arr && arr.length) {
        this.$store.commit("setCurCoin", arr[0]);
      }
      localStorage.setItem("coinCode", command);
      localStorage.setItem("Cur_Chips", this.curCoin.isExperienceCoinCode ? this.curCoin.experience : this.curCoin.chips)
      await selectWallet({ coinCode: command }).then((res) => {
        this.$store.commit("setSelectCoin", command);
        if (!once) {
          if (isGame()) {
            // 在游戏中就刷新页面
            window.location.reload();
          }
        }
      });
    },
    // showWalletBalance() {
    //   this.$router.push("/user/wallet");
    // },
    handleCommand(data) {
      console.log(data, "kkkkkkkkkkkkkkk");
      this.$eventPost("click", {
        eid: `101_0_0_133`,
        time: Date.now(),
        type: data.type,
        route: data.route,
      });
      const links = ["accountInfo", "promo", "router"];
      if (links.includes(data.type)) {
        this.$router.push(data.route);
      } else if (data.type === "Exchange") {
        // 兑换
        this.showExchange();
      } else if (data.type === "chargeExchange") {
        // 充值
        this.showCharge();
      } else {
        // console.log(this[data.type](data));
        // this[data.type](data);
        if (data.type === "signOut") {
          this.$store.dispatch("signOutPs");
          this.$message({
            message: this.$t("Datalang.Menu_BTM_logout"),
            type: "success",
            showClose: true,
          });
        }
      }
    },
    showCharge() {
      this.$eventPost("click", {
        eid: `101_0_0_130`,
        time: Date.now(),
      });
      this.$Bus.$emit("showCharge", { show: true });
    },
    showExchange() {
      this.$eventPost("click", {
        eid: `101_0_0_131`,
        time: Date.now(),
      });
      this.$Bus.$emit("showExchange", { show: true });
    },
    clickFun(type, eid) {
      const objStr = {
        0: "Login",
        1: "Register",
      };
      this.$eventPost("click", {
        eid,
        time: Date.now(),
      });
      this.$Bus.$emit("showLogin", { show: true, tab: objStr[type] });
    },
    ...mapActions(["signOutPs", "setMenuBar"]),
    chargeExchange(data) {
      this.$isPopShow({
        show: true,
        views: data.route,
        data: {
          title: data.title,
        },
      });
    },
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.commonSySize);
  },
  destroyed() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },
  activated() {},
};
</script>
<style>
.lang .el-input__inner {
  width: 130px;
  border-radius: 14px;
  padding-left: 30px;
}
</style>
<style lang="scss" scoped>
.search-icon {
  margin: 0 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 35px;
  height: 35px;
  background: var(--button-1100);
  border-radius: var(--radius-100);
  &:hover {
    background: var(--button-1101);
  }
  .icon {
    width: 20px;
  }
}
::v-deep .el-avatar {
  border: 1px solid var(--border-color-100) !important;
  cursor: pointer;
}
.flex-box {
  display: flex;
  align-items: center;

  &.right {
    justify-content: flex-end;
  }
}
.cur-lang-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 35px;
  height: 35px;
  background: var(--button-1100);
  border-radius: var(--radius-100);
  &:hover {
    background: var(--button-1101);
  }
}
.cur-lang-icon-new {
  width: 20px;
  height: 20px;
  display: block;
  border-radius: 50%;
  -webkit-border-radius: 50%;
  cursor: pointer;
}

.lang-row-wrap {
  display: flex;
  align-items: center;

  .language-icon {
    width: 20px;
    height: 20px;
    margin-right: 10px;
  }
}

.lang {
  position: relative;

  .cur-lang-icon {
    position: absolute;
    width: 20px;
    left: 6px;
    top: 16px;
    z-index: 1;
    border-radius: 50%;
    -webkit-border-radius: 50%;
    box-shadow: 0px 3px 5px 0px #ddd;
  }

  :deep(.el-select) {
    .el-input .el-select__caret {
      // background: url("~@/assets/new/xiala_btn.png") no-repeat;
      transform: rotateZ(0deg);
      appearance: none;
      background-size: 15px 8px;
      width: 15px;
      height: 8px;
      position: absolute;
      top: 24px;
      right: 3px;
    }

    .el-icon-arrow-up:before {
      content: "";
    }
  }
}

.lgoin-button {
  text-align: center;
  height: 36px;
  min-width: 110px;
  padding: 0 10px;
  box-sizing: border-box;
  &:hover {
    opacity: 0.8;
  }

  &:nth-child(1) {
    height: 36px;
    min-width: 110px;
    padding: 0 10px;
    color: var(--font-color-1401);
    // border-color: transparent;
    background: var(--background-600);
    border: 1px solid var(--border-color-300);
    //  @include buttonPrimary;
  }

  &:nth-child(2) {
    height: 36px;
    min-width: 110px;
    @include buttonYellow;
  }
}

.p-header .recharge {
  font-size: 12px;
  color: var(--font-color-1300);
  height: 36px;
  line-height: 36px;
  min-width: 90px;
  background: url("~@/assets/charge/chongzhi_bg.gif") no-repeat;
  background-size: 100% 100%;
  cursor: pointer;
}

.p-header .withdraw {
  position: relative;
  height: 36px;
  min-width: 90px;
  padding: 0 10px;
  @include buttonYellow;
  .firstWithdrawTis-wrap {
    position: absolute;
    top: 42px;
    left: 0;
    width: 220px;
    font-size: 14px;
    line-height: 18px;
    padding: 5px 10px;
    box-sizing: border-box;
    color: var(--font-color-200);
    z-index: 9;
    .triangle {
      display: block;
      position: absolute;
      top: -6px;
      left: 50px;
      width: 0;
      height: 0;
      border-left: 6px solid transparent;
      border-right: 6px solid transparent;
      border-bottom: 6px solid var(--background-1400);
      opacity: 0.8;
    }
    .text1 {
      width: 100%;
      position: relative;
      z-index: 1;
      text-wrap: wrap;
      word-break: break-word;
    }
    .bg {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: var(--background-1400);
      opacity: 0.8;
      border-radius: 10px;
    }
  }
}

.modal-info {
  word-break: break-word;

  div {
    line-height: 24px;
  }

  .btn-content {
    display: flex;
    justify-content: center;
    .el-button {
      @include buttonYellow;
    }
  }
}

.wallet_list_header {
  top: 60px !important;
  max-height: 70vh;
  overflow-y: auto;

  .is-disabled {
    color: var(--font-color-300);
    pointer-events: auto;
  }
}

.el-dropdown-menu.el-popper {
  padding: 10px;

  .qbHeaer,
  .qbFooter {
    cursor: auto;

    .el-icon-question {
      cursor: pointer;
      margin-left: 5px;
    }
  }

  .qbHeaer {
    padding: 0 10px;
    margin: 0 10px;
    &:hover {
      background: transparent !important;
      color: var(--font-color-100);
    }
  }

  .qbItem {
    margin-bottom: 2px;
    border-radius: 3px;
    -webkit-border-radius: 3px;
    -moz-border-radius: 3px;
    -o-border-radius: 3px;
    padding: 0 10px;
    margin: 0 10px;
  }

  .is-disabled {
    color: var(--font-color-300) !important;
  }

  .qbFooter {
    text-align: center;
    height: 36px;
    padding: 8px 0;

    .walletBtn {
      cursor: pointer;
      line-height: 24px;
      padding: 6px 20px;
      display: inline-block;
      overflow: hidden;
      position: relative;
      @include buttonPrimary;

      &.first {
        &:before {
          content: "";
          position: absolute;
          width: 200px;
          height: 30px;
          /**白光的宽度，可根据实际调整**/
          background-image: linear-gradient(to bottom, transparent, rgba(255, 255, 255, 0.5), transparent);
          -webkit-transform: rotate(-45deg);
          -moz-transform: rotate(-45deg);
          -ms-transform: rotate(-45deg);
          -o-transform: rotate(-45deg);
          transform: rotate(-45deg);
          -webkit-animation: searchLights 3s ease-in 1s infinite;
          -o-animation: searchLights 3s ease-in 1s infinite;
          animation: searchLights 3s ease-in 1s infinite;
          /**第一个数字参数控制扫光速度，数字越大越慢**/
        }

        @keyframes searchLights {
          0% {
            left: -120px;
            top: -20px;
          }

          100% {
            left: 100px;
            top: 100px;
          }
        }
      }
    }

    .disable_btn {
      background: #ccc;
      cursor: not-allowed;
    }
    &:hover {
      background: transparent !important;
    }
  }
}

.qbDiv {
  position: relative;
  padding: 0 140px 0 25px;
  &.experienceWrap {
    margin-bottom: 20px;
  }
  .experience_coin {
    line-height: 1;
    font-size: 12px;
    color: var(--font-color-1800);
    .el-icon-question {
      pointer-events: all;
      cursor: pointer;
      margin-left: 5px;
      font-size: 14px;
      color: var(--font-color-200);
    }
  }

  img {
    position: absolute;
    width: 16px;
    height: 16px;
    left: 0;
    top: 8.5px;
  }

  .chips {
    position: absolute;
    width: 140px;
    right: 0;
    top: 0;
    text-align: right;
  }
}

.symbol_coin {
  line-height: 36px;
  // padding-left: 35px;
}

.symbol_coin.symbol_coin1 {
  position: relative;
  line-height: 18px;

  .symbol_span {
    // position: absolute;
    left: 0;
    top: 0;
    width: 30px;
    text-align: right;
    padding-right: 5px;
  }
}

.sports-list {
  background-color: transparent !important;
  border: none;
  box-shadow: none;

  .icon {
    width: 30px;
    height: 30px;
    margin-right: 10px;
  }

  .el-dropdown-menu__item {
    border-radius: 10px;
    margin-top: 3px;
    display: flex;
    align-items: center;

    // &:hover {
    //   .icon-ag {
    //     background: url("~@/assets/img/head/icon_ag_xz.png");
    //   }

    //   .icon-bti {
    //     background: url("~@/assets/img/head/icon_bti_xz.png");
    //     background-repeat: no-repeat;
    //     width: 30px;
    //     height: 30px;
    //     display: inline-block;
    //     background-size: contain;
    //     margin-right: 10px;
    //     background-position: center;
    //   }
    // }

    // .icon-ag {
    //   background: url("~@/assets/img/head/icon_ag.png");
    //   background-repeat: no-repeat;
    //   width: 16px;
    //   height: 16px;
    //   display: inline-block;
    //   background-size: contain;
    //   width: 36px;
    //   height: 20px;
    //   margin-right: 10px;
    // }

    // .icon-bti {
    //   background: url("~@/assets/img/head/icon_bti.png");
    //   background-repeat: no-repeat;
    //   width: 30px;
    //   height: 30px;
    //   display: inline-block;
    //   background-size: contain;
    //   margin-right: 10px;
    //   background-position: center;
    // }
  }
}

.login-btn {
  text-align: right;
}

.box-flex {
  display: flex;
  text-align: center;
  justify-content: flex-end;
  align-items: center;
}

.head-user-info {
  ::v-deep .el-avatar {
    background-color: transparent;
    cursor: pointer;
    overflow: hidden;
    cursor: pointer;
    > img {
      transition: transform linear 0.3s;
    }
    &:hover > img {
      transform: scale(1.2);
    }
  }

  .vip-box {
    margin-right: 16px;
    font-size: 14px;
    color: var(--font-color-100);
  }

  .chips-box {
    max-width: 160px;
    margin: 0 12px;
    height: 32px;
    padding: 4px 8px;
    line-height: 22px;
    font-size: 14px;
    text-align: left;
    background: var(--background-900);
    border-color: var(--background-900);
    color: var(--font-color-100);

    .chips-num {
      color: var(--font-color-100);
    }
  }
}

.badge-item {
  ::v-deep .el-badge__content {
    border: none;
  }
}

.dropdown-box {
  ::v-deep .popper__arrow {
    &::after {
      border-bottom-color: var(--background-800);
    }
  }

  .el-dropdown-menu__item {
    min-width: 140px;
    max-width: 300px;
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    border-radius: 3px;
    padding: 5px 10px;
    overflow: hidden;
    display: flex;
    align-items: center;
    .icon {
      width: 16px;
      height: 16px;
      vertical-align: unset;
    }

    .title {
      margin-left: 12px;
    }

    // &:hover {
    //   background-color: var(--background-1400) !important;
    //   color: var(--font-color-100);
    // }
  }
}

.Casino,
.Sports {
  display: block;
  float: left;
  height: 32px;
  line-height: 32px;
  padding: 3px 12px;
  z-index: 3;
  border-radius: 30px;
  color: var(--font-color-100);
  margin: 0 5px;

  &.active {
    background: var(--background-600);
  }
}

.Casino:hover,
.Sports:hover {
  display: block;
  float: left;
  height: 32px;
  line-height: 32px;
  padding: 3px 12px;
  z-index: 3;
  border-radius: 30px;
  background: var(--background-600);
}

.Casino img {
  width: 26px;
  height: 22px;
  margin: 3px 0;
  float: left;
}

.Sports img {
  width: 24px;
  height: 24px;
  margin: 4px 0;
  float: left;
}

.Casino em,
.Sports em {
  float: right;
  margin-left: 12px;
  font-size: 14px;
}

.Casino:hover img {
  width: 26px;
  height: 22px;
  margin: 3px 0;
  float: left;
  animation: Casino 4s linear infinite;
}

.Sports:hover img {
  width: 24px;
  height: 24px;
  margin: 4px 0;
  float: left;
  animation: Sports 4s linear infinite;
}

// .coin-img {
//   width: 30px;
//   height: 30px;
//   border-radius: 50%;
//   background: #ccc;
// }

.Casino:hover em,
.Sports:hover em {
  float: right;
  margin-left: 12px;
  font-size: 14px;
  color: var(--font-color-100);
}

.transition {
  transition: 0.5s;
  -ms-transition: 0.5s;
  -moz-transition: 0.5s;
  -webkit-transition: 0.5s;
}

@keyframes Casino {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

@keyframes Sports {
  0% {
    transform: rotate(360deg);
  }

  100% {
    transform: rotate(0deg);
  }
}
.flex {
  display: flex;
  align-items: center;
  height: 20px;
}
.qbMode {
  background: var(--pulldown-100) !important;
  padding: 0 !important;
  .qbModeMain {
    min-width: 300px;
    .qbModeMainTop {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 30px;
      line-height: 30px;
      font-size: 13px;
      background: var(--background-400);
      padding: 0 10px;
      border-radius: 5px 5px 0 0;
    }
    .qbModeMainCon {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 50px;
      padding: 10px;
      box-sizing: border-box;
      background: var(--background-1502);
      border-radius: 0 0 5px 5px;
      .amount{
        font-size: 16px;
      }
      .qbModeMainConRight{
        display: flex;
        align-items: center;
        .btn {
          font-size: 12px;
          cursor: pointer;
          line-height: 24px;
          padding: 3px 10px;
          display: inline-block;
          overflow: hidden;
          position: relative;
          @include buttonPrimary;
        }
      }
    }
  }
}
.godVip-box {
  margin-left: 18px;
  .el-dropdown-link {
    display: flex;
    justify-content: space-around;
    align-items: center;
    min-width: 125px;
    height: 36px;
    line-height: 36px;
    padding: 8px;
    border-radius: var(--radius-200);
    color: var(--font-color-200);
    background: var(--background-700);
    cursor: pointer;
    box-sizing: border-box;
    &.el-dropdown-link1 {
      height: 46px;
      line-height: 20px;
      img {
        width: 16px;
        height: 16px;
        margin-right: 4px;
      }
    }
    img {
      width: 22px;
      height: 22px;
      margin-right: 4px;
    }
  }
}

.p-header {
  color: var(--font-color-200);
  margin: 0 auto;
  padding: 0 15px;
  height: 60px;
  display: flex;
  align-items: center;
  // background: var(--background-200);
  box-shadow: var(--boxShadow-700);

  .slogan {
    padding-left: 200px;
    font-size: 16px;
    color: var(--font-color-900);
  }

  .topnav {
    padding-left: 100px;
    display: flex;
    align-items: center;
    &-item {
      padding: 0 10px;
      display: flex;
      align-items: center;
      color: var(--font-color-700);
      cursor: pointer;
      &:hover {
        color: var(--font-color-200);
      }
      &-icon {
        width: 20px;
        height: 20px;
        padding-right: 10px;
      }
    }
  }

  .menu-icon {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: transform ease 0.3s;
    &.left {
      margin-right: 15px;
    }
    &.right {
      margin-left: 10px;
    }
    &.show-menu {
      img {
        transform: rotate(0);
      }
    }

    img {
      transition: transform ease 0.5s;
      transform-origin: center;
      display: block;
      width: 38px;
      transform: rotate(-180deg);
    }
  }

  .logo-box {
    justify-content: flex-start;

    .logo {
      height: 40px;
      cursor: pointer;
    }

    .collapse-on-off {
      font-size: 28px;
      margin: 0 12px 0 6px;
      cursor: pointer;
      z-index: 9;
    }

    .mainNav {
      display: flex;
    }
  }
  .right-wrap {
    display: flex;
    /* justify-content: space-between; */
    flex: 1;
    width: 100%;
    height: 100%;
    justify-content: flex-end;
    .action-wrap {
      display: flex;
      align-items: center;
      .user-wrap {
        margin-left: 30px;
        display: flex;
        align-items: center;
        min-width: 120px;
      }
    }
  }
}

::v-deep .changeTime.el-select .el-input__inner {
  background: none;
  color: var(--font-color-100);
  border: none;
}

::v-deep .changeTime.el-select .el-input__icon::before {
  content: "";
}

.xiala {
  left: 165px;
  cursor: pointer;
}

.account_info {
  line-height: 18px;
  font-size: 12px;
  margin-left: 5px;

  .account_vip {
    position: relative;
    width: 40px;
    padding-left: 18px;
    height: 18px;
    line-height: 18px;
    border-radius: 9px;
    background: var(--background-700);
    color: var(--font-color-900);
    margin-top: 3px;

    .p_vip {
      position: absolute;
      left: -6px;
      top: -1px;
      width: 24px;
    }
  }
}

.el-select-dropdown__item {
  display: flex;

  .language-icon {
    height: 24px;
    margin-top: 5px;
    border-radius: 50%;
    -webkit-border-radius: 50%;
    box-shadow: 0px 3px 5px 0px #ddd;
  }

  .language-title {
    margin-left: 10px;
  }
}
.experienceDiv{
  padding-left: 25px;
  padding-bottom: 5px;
}
#vStep {
  position: relative; /* 作为定位基准 */
  display: inline-block;
}

.dropdown-tip {
  position: absolute;
  top: 100%;            /* 紧贴 dropdown 底部 */
  left: 50%;            /* 水平居中 */
  transform: translateX(-50%);
  margin-top: 16px;
  padding: 4px 10px;
  background: var(--background-500);
  color: #fff;
  font-size: 12px;
  border-radius: 4px;
  white-space: nowrap;
  z-index: 10;
}

.dropdown-tip-arrow {
  position: absolute;
  top: -6px;            /* 箭头顶到提示框 */
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 6px solid var(--background-500);
}
</style>
